'use client'

import { urlForImage } from "@/sanity/lib/image"
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import { createDataAttribute } from "next-sanity"
import Image from "next/image"

interface ImageCarouselProps {
	images: any
	documentId: string
	_key: string
}

export default function ImageCarousel({images, documentId, _key}:ImageCarouselProps) {
	const [emblaRef, emblaApi] = useEmblaCarousel({
		align: 'start',
		loop: true
	}, [Autoplay({delay: 4000})])

	return (
		<div
			className={`section col-span-full my-section--sm`}
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}
		>
			<div ref={emblaRef} className="embla w-full overflow-clip">
				<div className="embla__container w-full flex">
					{images?.map((image, index) => (
						<div key={`slide-${index}`} className="embla__slide w-4/5 md:w-2/5 h-full flex-none mr-4 md:mr-8">
							<Image
								className={`w-full h-auto object-cover rounded overflow-clip`}
								src={urlForImage(image).url()}
								width={image?.asset?.metadata?.dimensions?.width}
								height={image?.asset?.metadata?.dimensions?.height}
								sizes="100vw"
								alt={image?.alt || ''}
								placeholder="blur"
								blurDataURL={image?.asset?.metadata?.lqip}
								unoptimized={image?.asset?.url?.includes(".gif") ? true : false} // mark Gif images as unoptimized (Next.js does not support Gif optimisation yet)
								quality={90}
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
